const TextValue = (props) => (
    <span>{props.value}</span>
)

export default TextValue;